import React from "react";
import "./PageTitle.css";

const PageTitle = ({ title, subtitle, subheader }) => {
	return (
		<div className="page-title">
			<h1>{title}</h1>
			{subheader && <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 400, color: '#888', textTransform: 'none' }}>Line: {subheader}</h4>}
			<span>{subtitle}</span>
			<div className="header-divider" style={{ margin: "0 auto" }}></div>
		</div>
	);
};

export default PageTitle;
